export default "__VITE_ASSET__a35c0d2b__"